import { FC } from 'react';
import { PageContainer } from '../../components/page/PageContainer';
import { PageHeader } from '../../components/page/PageHeader';
import { PageSizer } from '../../components/page/PageSizer';
import strings from './documents.translations';
import { CategorySmallLink } from '../../components/links/CategorySmallLink';
import { NavPage } from '../../components/page/Breadcrumbs';
import { SuspenseCard } from '../../components/card/SuspenseCard';
import { FaBoxOpen, FaFolder } from 'react-icons/fa';
import { SearchBar } from '../../components/file/SearchBar';
import { CardDivider } from '../../components/card/CardDivider';
import { IconLink } from '../../components/links/IconLink';
import { useCategories } from '../../services/api/hooks/categories';
import { useIntroduction } from '../../services/graph/hooks/introduction';

export const Documents: FC = () => {
  const breadcrumbs: NavPage[] = [
    {
      name: strings.common.pages.documents,
      to: '/documents'
    }
  ];

  const categories = useCategories();
  const introduction = useIntroduction();

  if (!introduction.data) {
    throw Error('Could not get image data');
  }

  return (
    <PageContainer>
      <PageHeader
        title={strings.common.pages.documents}
        breadcrumbs={breadcrumbs}
        imageUrl={introduction.data.backgroundImages.documentsPage}
      ></PageHeader>
      <PageSizer className="py-5 flex flex-col gap-5">
        <SearchBar />
        <SuspenseCard className="p-5 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-5">
          <IconLink
            link={{
              title: strings.myDocuments,
              to: 'myDocuments',
              Icon: FaFolder
            }}
          />
          <IconLink
            secondary
            link={{
              title: strings.uploadFile,
              to: 'upload',
              Icon: FaBoxOpen
            }}
          />
          <CardDivider className="col-span-full" />
          {categories.map(cat => {
            if (!cat.id) throw new Error('Category information is missing');
            return <CategorySmallLink key={cat.id} category={cat} />;
          })}
        </SuspenseCard>
      </PageSizer>
    </PageContainer>
  );
};
